import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import updateSearchFields from "@insite/client-framework/Store/Pages/Addresses/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Search from "@insite/mobius/Icons/Search";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";

export interface AddressBookSearchBoxStyles {
    searchText?: TextFieldProps;
    addressSearchHead?: InjectableCss;
    addressSearchSubhead?: InjectableCss;
    gridContainer?: GridContainerProps;
    addressBookSearchGridItem?: GridItemProps;

}

export const searchBoxStyles: AddressBookSearchBoxStyles = {
    searchText: { iconProps: { src: Search } },
    addressBookSearchGridItem: {
        css:css`
            border-radius: 0.125rem;
            background-color: ${themeColors.colorWhite};
            box-shadow: 0 0.125rem 0.25rem 0.25rem rgba(0,0,0,0.03);
            padding: 2.125rem 2.125rem 2.125rem 2.0625rem;
            min-height: 15.625rem;
            
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            min-height: auto;
                            padding: 1.5rem 2.25rem 1.5rem 1.875rem;
                        `,
                    ],
                    "max",
                )}

        `,
    },
    addressSearchHead: {
        css:css`
        color: ${themeColors.colorPrimaryButtonFocus};
        font-family: Roboto;
        font-size: 1.125rem;
        font-weight: ${themeFontWeights.fontWeightMedium};
        letter-spacing: 0;
        padding-bottom: 2.125rem;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                css`
                    padding-bottom: 0.375rem;
                `,
            ],
            "max",
        )}
        `,        
    },
    addressSearchSubhead: {
        css:css`
        display: block;
        color: ${themeColors.colorSquidInk};
        font-family: Roboto;
        font-size: 0.875rem;
        letter-spacing: 0.16px;
        padding-bottom: 1.5625rem;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                css`
                    padding-bottom: 0.9375rem;
                `,
            ],
            "max",
        )}
        `,
    }
    
};

const styles = searchBoxStyles;

interface OwnProps extends WidgetProps {}

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

class AddressBookSearchBox extends React.Component<Props> {
    searchTimeoutId:NodeJS.Timeout | undefined;
    readonly searchMinimumCharacterLength = 3;

    searchTextChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        clearTimeout(this.searchTimeoutId);
        const searchText = event.currentTarget.value;
        if (searchText.length > 0 && searchText.length < this.searchMinimumCharacterLength) {
            return;
        }
        this.searchTimeoutId = setTimeout(() => {
            this.props.updateSearchFields({
                filter: searchText,
                page: 1,
            });
        }, 250);
    };

    componentWillUnmount() {
        if (typeof this.searchTimeoutId === "number") {
            clearTimeout(this.searchTimeoutId);
        }
        this.props.updateSearchFields({
            filter: "",
            page: 1,
        });
    }

    render() {
        return (
            <>
                <StyledWrapper {...styles.addressBookSearchGridItem}>
                    <Typography as="h5" {...styles.addressSearchHead}>{translate('Find Address')}</Typography>
                    <Typography {...styles.addressSearchSubhead}>{translate('Find an address from your address book')}</Typography>
                    <TextField
                        placeholder={translate("")}
                        {...styles.searchText}
                        onChange={this.searchTextChangeHandler}
                    />
                </StyledWrapper>
            
            </>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(AddressBookSearchBox),
    definition: {
        group: "Addresses",
        allowedContexts: ["AddressesPage"],
    },
};

export default widgetModule;
